import Link from 'next/link';
import { DisplayHeading, Eyebrow, PlaneIcon } from '../Landing/ui';

// Dashed-route flourish marking a chapter break — use sparingly (2-3 per
// page at most).
export function SectionDivider({ className = '' }) {
  return (
    <div
      aria-hidden="true"
      className={`tw-flex tw-items-center tw-justify-center tw-gap-3 ${className}`}
    >
      <span className="tw-h-px tw-w-16 tw-border-0 tw-border-t tw-border-dashed tw-border-[#C9C0AA] dark:tw-border-[#3A4D44] [border-top-width:2px]" />
      <PlaneIcon className="tw-h-4 tw-w-4 tw-rotate-90 tw-text-primary-600/60 dark:tw-text-primary-300/50" />
      <span className="tw-h-px tw-w-16 tw-border-0 tw-border-t tw-border-dashed tw-border-[#C9C0AA] dark:tw-border-[#3A4D44] [border-top-width:2px]" />
    </div>
  );
}

// Standard section opener for guide pages: mono eyebrow over a Fraunces
// heading, with an optional mono "more →" link on the baseline.
export default function SectionHeading({
  eyebrow,
  children,
  moreHref,
  moreLabel,
  center,
  className = '',
}) {
  return (
    <div
      className={`tw-mb-8 ${
        center
          ? 'tw-text-center'
          : 'tw-flex tw-flex-wrap tw-items-baseline tw-justify-between tw-gap-2'
      } ${className}`}
    >
      <div>
        {eyebrow && <Eyebrow className="tw-mb-3">{eyebrow}</Eyebrow>}
        <DisplayHeading
          as="h2"
          className="tw-text-3xl sm:tw-text-4xl tw-leading-[1.1]"
        >
          {children}
        </DisplayHeading>
      </div>
      {moreHref && (
        <Link
          href={moreHref}
          prefetch={false}
          className="tw-text-sm tw-font-semibold tw-text-primary-700 dark:tw-text-primary-300 tw-no-underline hover:tw-underline"
        >
          {moreLabel} →
        </Link>
      )}
    </div>
  );
}
